type Division = {
    code: number;
    name: string;
};

const divisions: Division[] = [
    { code: 16, name: "ALCARE" },
    { code: 17, name: "ALEM-GLYCODIN" },
    { code: 38, name: "ALEMBIC CORP" },
    { code: 37, name: "ALGROW" },
    { code: 36, name: "Access" },
    { code: 41, name: "CARDIGEM" },
    { code: 26, name: "CORAZON" },
    { code: 24, name: "CORIUM" },
    { code: 19, name: "Corp Hospital" },
    { code: 29, name: "ELENA" },
    { code: 18, name: "ENTERON" },
    { code: 50, name: "EXPORTS" },
    { code: 23, name: "EYECARE" },
    { code: 40, name: "FARMCURE" },
    { code: 6, name: "FRANCHISEE" },
    { code: 25, name: "GASTRON" },
    { code: 4, name: "GENERIC" },
    { code: 33, name: "HOSPI-ALCIBUT" },
    { code: 20, name: "INTENSA" },
    { code: 15, name: "MAXIS" },
    { code: 2, name: "MEGACARE" },
    { code: 30, name: "NEPAL ACUTE" },
    { code: 31, name: "NEPAL CV" },
    { code: 32, name: "NEPAL VET" },
    { code: 11, name: "NSA" },
    { code: 22, name: "OSTEOFIT" },
    { code: 28, name: "OURON" },
    { code: 42, name: "PETAL" },
    { code: 1, name: "PHARMA" },
    { code: 9, name: "POUL-INST" },
    { code: 34, name: "Pegasus" },
    { code: 27, name: "RESPIRATORY" },
    { code: 8, name: "SPECIA" },
    { code: 14, name: "SUMMIT" },
    { code: 10, name: "SUPRACARE" },
    { code: 99, name: "UNDEFINED" },
    { code: 35, name: "Unicorn" },
    { code: 3, name: "VET-LIVE" },
    { code: 7, name: "VET-NSA" },
    { code: 5, name: "VET-POUL" },
    { code: 21, name: "ZENOVI" }
];

export function getDivisionName(code: number | string): string | undefined {
    const numericCode = typeof code === 'string' ? parseInt(code, 10) : code;
    const division = divisions.find((div) => div.code === numericCode);
    return division ? division.name : "HO User";
}
